import React from 'react'
import ButtonWrap from '../../../ui/layouts/ButtonWrap'
import { SubmitButton } from 'ui'
import { Translation } from '@morningtrain/react-translations'

export default function AssignBadgeSmartviewFooter () {
  return (
    <ButtonWrap>
      <SubmitButton>
        <Translation name='generic.save' />
      </SubmitButton>
    </ButtonWrap>
  )
}
